import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { globalConfig } from "./utils/config";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";

const globalConfigUrl = "config.json";


axios
  .get(globalConfigUrl)
  .then((response) => {
    if (response.headers["content-type"] !== "application/json") {
      throw new Error("Global config is not a JSON file");
    }

    globalConfig.initialize(response.data);
  })
  .catch((e) => {
    if (process.env.NODE_ENV === "development") {
      console.warn(
        `Failed to load global configuration from '${globalConfigUrl}', using the default configuration instead.`
      );
    } else {
      console.error(
        "Error while fetching global config.",
        `Have you provided the config file '${globalConfigUrl}'?`,
        e
      );
    }

    globalConfig.initialize({
      BASE_AUTH_URL: "http://localhost:3000",
    });
  });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals();
